import { createSlice } from '@reduxjs/toolkit';
import { createFilterInitialState, filterReducers, FilterState } from 'common/utils/sliceUtils/filterSliceUtils';

type StateWithProductPackageRals = { productPackageRals: FilterState };

const productPackageRals = createSlice({
    name: 'productPackageRals',
    initialState: createFilterInitialState(),
    reducers: () => ({
        ...filterReducers,
    })
});

// eslint-disable-next-line no-restricted-syntax
export default productPackageRals.reducer;
export const { addNewFilter, removeFilter, clearFilters } = productPackageRals.actions;
export const selectFilters = (state: StateWithProductPackageRals) => state.productPackageRals.filters;
